import { useMutation, useQueryClient } from 'react-query';
import { getInvoiceDataUseCases } from '@subscriptions/composition';
import type { CreateInvoiceDataDto, InvoiceDataViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for creating invoice data (datos fiscales).
 *
 * @returns Mutation result for creating invoice data
 */
export const useCreateInvoiceData = () => {
  const queryClient = useQueryClient();
  const { createInvoiceData } = getInvoiceDataUseCases();

  return useMutation<InvoiceDataViewDto, Error, CreateInvoiceDataDto>((dto) => createInvoiceData.execute(dto), {
    onSuccess: (createdInvoiceData) => {
      queryClient.setQueryData<InvoiceDataViewDto[]>(['subscriptions', 'invoice-data', 'list'], (current) => {
        if (current?.some((item) => item.uuid === createdInvoiceData.uuid)) {
          return current;
        }

        return [createdInvoiceData, ...(current ?? [])];
      });

      queryClient.invalidateQueries(['subscriptions', 'invoice-data', 'list']);
    },
  });
};
